import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Navigation from '../../../Shared/Navigation/Navigation';
import blogDom from '../../../../images/blogs/Dom-1.png'
import blogCrud from '../../../../images/blogs/CRUD.jpeg'


const Blogs = () => {
    return (
        <>
            <Navigation></Navigation>
            <Container>
                <Row>
                    <Col md={2}></Col>
                    <Col md={4} xs={12}>

                        <Card className=' text-dark' >
                            <Card.Img variant="top" src={blogDom} className='img-fluid' style={{ 'height': '220px' }} />
                            <Card.Body>
                                <Card.Title>React Virtual DOM</Card.Title>
                                <Card.Text className='text-start p-2 mt-3'>
                                    Virtual DOM is just a copy of real DOM. Virtual dom is a programming concept. It is an in-memory representation of Real DOM. It is where the representation of UI is kept in mind and makes synchronization with Real DOM.
                                </Card.Text>
                            </Card.Body>
                            <Card.Footer className=' border-top p-0'>
                                <NavLink to="/reactDomDetails" className="text-decoration-none text-dark ">
                                    <Button className=" w-100">View Details</Button>
                                </NavLink>

                            </Card.Footer>
                        </Card>

                    </Col>
                    <Col xs={12} md={4}>
                        <Card className='text-dark' >
                            <Card.Img variant="top" src={blogCrud} className='img-fluid' style={{ 'height': '220px' }} />
                            <Card.Body>
                                <Card.Title>CRUD Operations</Card.Title>
                                <Card.Text className='text-start p-2 mt-3'>
                                    The acronym CRUD stands for create, read, update and delete.It can be described  user-interface conventions that allow viewing, searching and modifying information through computer-based forms and reports
                                </Card.Text>
                            </Card.Body>
                            <Card.Footer className='border-top p-0'>
                                <NavLink to="/crudOperation" className="text-decoration-none text-dark ">
                                    <Button className="w-100">View Details</Button>
                                </NavLink>
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col md={2}></Col>
                </Row>
            </Container>
        </>
    );
};

export default Blogs;